/**
 * Seychelles rupee.
 */
export var SCR = {
  code: 'SCR',
  base: 10,
  exponent: 2
};